import React from 'react'
import styled from 'styled-components'
import Portable from '../portable'

const Container = styled.div`
  width: 100%;
  padding: 70px;
  text-align: center;
  border-radius: 30px;
  @media(max-width: 768px) {
    padding: 24px;
  }
  .details {
    display: flex;
    column-gap: 40px;
    @media(max-width: 1024px) {
      flex-direction: column;
    }
  }
  p {
    max-width: 762px;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
  }
  img {
    margin-top: 60px;
    margin-bottom: 60px;
    margin-left: auto;
    margin-right: auto;
    &.main {
      max-width: 520px;
      @media(max-width: 768px) {
        max-width: 75vw !important;
        margin-top: 30px;
        margin-bottom: 30px;
      }
    }
    &.logo {
      margin-bottom: 0;
      max-width: 300px;
      max-height: 200px;
      @media(max-width: 768px) {
        max-width: 60vw;
        margin-top: 30px;
        margin-bottom: 30px;
      }
    }
  }
  &.odd {
    background-color: #fff;
    border: 2px solid #000;
  }
  &.even {
    background-color: #f0f0f0;
  }
`

const Sector = ({module, index}) => {

  const { heading, mainImage, body, logoImage, mapImage } = module

  function shouldHaveGreyBackground(index, heading) {
    if(heading.toLowerCase().includes('transition')) {
      return false
    } else {
      return true
    }
  }

  const cn = shouldHaveGreyBackground(index, heading) ? 'even' : 'odd';

  return (
    <Container className={cn}>
      <h3>{heading}</h3>
      { logoImage && <img className="logo" src={logoImage.asset.publicUrl} alt="" /> }
      <div className="details">
        { mainImage && <img className="main" src={mainImage.asset.publicUrl} alt="" /> }
        { mapImage && <img className="main" src={mapImage.asset.publicUrl} alt="" /> }
      </div>
      { body && <Portable blocks={body} /> }
    </Container>
  )
}

export default Sector
